import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { destroy } from "@lib/requests"
import Fuse from "fuse.js"
import TomSelect from "@lib/custom-tom-select"
import { closeModalAndVisitPath } from "@lib/utils"

// Connects to data-controller="global-search"
export default class extends Controller {
  
  static targets = ["searchField", "terms"]
  
  connect() {
    // Destroy existing Tom Select instance if it exists (e.g., from previous connection)
    if (this.searchFieldTarget.tomselect) {
      this.searchFieldTarget.tomselect.destroy()
    }

    const selectOptions = { 
      labelField: "label", 
      searchField: [], 
      load: this.loadResults.bind(this),
      onItemAdd: this.onSelect.bind(this),
      shouldLoad: function(query) {
        return true;  // Always trigger the load function (so we can clear the options on blank queries)
      }
    }
    this.select = new TomSelect(this.searchFieldTarget, selectOptions)
  }

  disconnect() {
    if (this.select) {
      this.select.destroy()
    }
  }

  async loadResults(query, callback) {
    this.select.clearSelect()
    if (!query.trim()) {
      callback([])
      return
    }

    // Get the server results
    const url = `/search?q=${query}`
    const response = await fetch(url)
    const results = await response.json()
    
    // Fuse the results
    const fuseSearch = new Fuse(results, {
      includeScore: true,
      keys: ["name", "label", "description"]
    })
    const fuseResults = fuseSearch.search(query).map(result => result.item)
    
    // Return the fuse results
    callback(fuseResults || [])
  }

  onSelect(value, item) {
    const selectedItem = this.select.options[value]
    this.select.setTextboxValue("")
    this.visitPath(selectedItem.path)
  }
  
  visitPath(path) {
    closeModalAndVisitPath(this, path)
  }
  
  applyQuery(event) {
    const { term } = event.params
    this.select.focus()
    this.select.setTextboxValue(term)
    this.select.fetchOptions(`/search?q=${term}`, { focus: true })
  }

  async deleteHistory(event) {
    await destroy("/recherches/destroy_all")
    this.termsTarget.innerHTML = ""
    this.select.focus()
  }
}
  